(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atri-included-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-atri-card-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.atriCardOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }
    if (event.target.matches('dialog.atri-included-card__dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atri-newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atri-newsletter')) {
    customElements.define('atri-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        if (!this.form.querySelector('button[type="submit"]')) return;
        // Install the transport before Shopify wraps form.submit to obtain its token.
        // An already-bound form retains its native, protected submission as a fallback.
        if (this.form.hasAttribute('data-hcaptcha-bound') || this.form.hasAttribute('data-recaptcha-bound')) return;
        this.form.submit = () => this.send();
        this.ready = new Promise((resolve) => {
          if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(this.form, resolve);
          else resolve();
        });
        this.form.addEventListener('submit', async (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.busy || !this.form.reportValidity()) return;
          this.setBusy(true);
          this.querySelector('.atri-letter__error').hidden = true;
          this.querySelector('[type="email"]').removeAttribute('aria-invalid');
          this.querySelector('[type="email"]').removeAttribute('aria-describedby');
          this.controller = new AbortController();
          this.timeout = setTimeout(() => {
            this.controller.abort();
            this.fail();
          }, 45000);
          try {
            await this.ready;
            if (this.busy) this.form.submit();
          } catch (error) {
            this.fail();
          }
        }, true);
      }

      setBusy(busy) {
        this.busy = busy;
        this.form.setAttribute('aria-busy', String(busy));
        const button = this.form.querySelector('button[type="submit"]');
        if (!button) return;
        button.disabled = busy;
        this.form.querySelector('[type="email"]').readOnly = busy;
        button.querySelector('[data-submit-label]').style.visibility = busy ? 'hidden' : '';
        button.querySelector('.atri-letter__spinner').hidden = !busy;
        const message = this.form.querySelector('[data-loading-message]').textContent;
        if (busy) button.setAttribute('aria-label', message);
        else button.removeAttribute('aria-label');
        this.form.querySelector('[data-loading-status]').textContent = busy ? message : '';
      }

      fail(message) {
        clearTimeout(this.timeout);
        const error = this.form.querySelector('.atri-letter__error');
        if (!error) return;
        error.textContent = message || this.form.querySelector('[data-error-message]').textContent;
        error.hidden = false;
        this.setBusy(false);
      }

      async send() {
        if (!this.busy || this.sending) return;
        this.sending = true;
        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            credentials: 'same-origin',
            signal: this.controller.signal
          });
          const url = new URL(response.url);
          if (url.origin !== window.location.origin) throw new Error('Unexpected response');
          if (/\/challenge(?:\/|$)/.test(url.pathname)) {
            clearTimeout(this.timeout);
            window.location.assign(url.href);
            return;
          }
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.busy) return;
          const returnedForm = html.getElementById(this.form.id);
          const returnedError = returnedForm?.querySelector('.atri-letter__error:not([hidden]), .errors');
          if (returnedError?.textContent.trim()) {
            this.fail(returnedError.textContent.trim());
            const email = this.form.querySelector('[type="email"]');
            email.setAttribute('aria-invalid', 'true');
            email.setAttribute('aria-describedby', this.form.querySelector('.atri-letter__error').id);
            email.focus({ preventScroll: true });
          } else if (response.ok && (url.searchParams.get('customer_posted') === 'true' || returnedForm?.querySelector('.atri-letter__success'))) {
            clearTimeout(this.timeout);
            const success = this.form.querySelector('[data-success-template]').content.cloneNode(true);
            this.setBusy(false);
            this.form.replaceChildren(success);
            this.form.querySelector('.atri-letter__success').focus({ preventScroll: true });
          } else {
            this.fail();
          }
        } catch (error) {
          this.fail();
        } finally {
          this.sending = false;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timeout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atri-subscription"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atri-subscription')) {
  customElements.define('atri-subscription', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-form]');
      this.copy = this.querySelector('[data-messages]').dataset;
      this.quantity = this.querySelector('[data-bag-count]');
      this.plan = this.querySelector('[data-plan]');
      this.locale = this.dataset.locale || 'en';
      this.minimum = this.earliestDelivery(new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()));
      this.month = new Date(this.minimum.getFullYear(), this.minimum.getMonth(), 1);
      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[name="properties[Bag size]"],[data-bag-count]')) this.updateVariant();
        this.updateSummary();
        this.flushPaymentFieldChanges();
      });
      this.querySelectorAll('[name="properties[Bag size]"]').forEach(input => input.addEventListener('click', () => {
        this.quantity.value = input.value === '250g' ? '2' : '1';
        this.dispatchFieldChange(this.quantity);
      }));
      this.quantity.addEventListener('input', () => {
        this.dispatchFieldChange(this.quantity);
      });
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        const step = Number(this.quantity.step) || 1;
        const min = Number(this.quantity.min) || 1;
        const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
        const current = Number(this.quantity.value) || min;
        this.quantity.value = Math.min(max, Math.max(min, current + Number(button.dataset.step) * step));
        this.dispatchFieldChange(this.quantity);
      }));
      this.querySelectorAll('[data-month]').forEach(button => button.addEventListener('click', () => {
        this.month.setMonth(this.month.getMonth() + Number(button.dataset.month));
        this.renderCalendar();
      }));
      this.form.addEventListener('submit', event => {
        const error = this.querySelector('[data-error]');
        if (!this.ready || !this.selectedDate || !this.allowed(this.parseDate(this.selectedDate))) {
          event.preventDefault();
          error.textContent = this.copy.invalid;
          error.hidden = false;
          this.querySelector('[data-days] button:not(:disabled)')?.focus();
        } else {
          this.form.querySelector('[name="return_to"]').value = '/checkout';
        }
      });
      this.updateVariant();
      this.selectDate(this.minimum);
      this.renderCalendar();
      this.updateSummary();
      this.flushPaymentFieldChanges();
    }
    parseDate(value) {
      const [year, month, day] = value.split('-').map(Number);
      return new Date(year, month - 1, day);
    }
    iso(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
    earliestDelivery(today) {
      const date = this.parseDate(today);
      let remaining = Math.max(2, Number(this.dataset.leadDays) || 2);
      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() > 0 && date.getDay() < 6) remaining -= 1;
      }
      return date;
    }
    allowed(date) {
      return date >= this.minimum && date.getDay() > 0 && date.getDay() < 6;
    }
    renderCalendar() {
      const days = this.querySelector('[data-days]');
      days.replaceChildren();
      this.querySelector('[data-month-label]').textContent = this.month.toLocaleDateString(this.locale, { month: 'long', year: 'numeric' });
      this.querySelector('[data-month="-1"]').disabled = this.month.getFullYear() === this.minimum.getFullYear() && this.month.getMonth() === this.minimum.getMonth();
      const offset = (this.month.getDay() + 6) % 7;
      for (let i = 0; i < offset; i++) days.append(document.createElement('span'));
      const count = new Date(this.month.getFullYear(), this.month.getMonth() + 1, 0).getDate();
      for (let day = 1; day <= count; day++) {
        const date = new Date(this.month.getFullYear(), this.month.getMonth(), day);
        const value = this.iso(date);
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = day;
        button.disabled = !this.allowed(date);
        button.setAttribute('aria-label', date.toLocaleDateString(this.locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }));
        button.setAttribute('aria-pressed', String(this.selectedDate === value));
        button.addEventListener('click', () => {
          this.selectDate(date);
          days.querySelectorAll('button').forEach(dayButton => dayButton.setAttribute('aria-pressed', String(dayButton === button)));
          this.updateSummary();
          this.dispatchFieldChange(this.querySelector('[data-date-value]'));
          this.dispatchFieldChange(this.querySelector('[data-day-value]'));
        });
        days.append(button);
      }
    }
    selectDate(date) {
      this.selectedDate = this.iso(date);
      this.querySelector('[data-date-value]').value = this.selectedDate;
      this.querySelector('[data-day-value]').value = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()];
      this.querySelector('[data-error]').hidden = true;
      this.querySelector('[data-chosen]').textContent = this.formatDate(date);
    }
    formatDate(date) {
      return date.toLocaleDateString(this.locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    }
    updateVariant() {
      const size = this.querySelector('[name="properties[Bag size]"]:checked').value;
      this.quantity.min = size === '250g' ? '2' : '1';
      if (this.quantity.value !== '' && Number(this.quantity.value) < Number(this.quantity.min)) this.quantity.value = this.quantity.min;
      const matches = [...this.querySelectorAll('[data-variant-option]')].filter(variant => variant.dataset.size === size && Number(variant.dataset.bags) === Number(this.quantity.value));
      this.variant = matches.length === 1 ? matches[0] : null;
      const previous = this.plan.value;
      this.plan.replaceChildren();
      const allocations = this.variant ? [...this.variant.querySelectorAll('[data-plan-option]')] : [];
      allocations.forEach(allocation => {
        const option = new Option(allocation.dataset.name, allocation.dataset.id);
        option.dataset.price = allocation.dataset.price;
        this.plan.add(option);
      });
      if (!allocations.length) {
        if (this.dataset.purchase !== 'true') {
          [this.copy.weekly, this.copy.fortnightly, this.copy.fourWeekly].forEach((label, index) => this.plan.add(new Option(label, `preview-${index}`)));
          if (previous.startsWith('preview-')) this.plan.value = previous;
        } else this.plan.add(new Option(this.copy.noPlan, ''));
      }
      if (allocations.some(allocation => allocation.dataset.id === previous)) this.plan.value = previous;
      else if (!previous && this.plan.options.length > 1) this.plan.selectedIndex = 1;
      this.plan.disabled = allocations.length === 0 && this.dataset.purchase === 'true';
      this.querySelector('[data-variant]').value = this.variant?.dataset.id || '';
      this.renderPlanChoices();
      this.pendingPaymentFields = [this.plan, this.querySelector('[data-variant]')];
    }
    renderPlanChoices() {
      const choices = this.querySelector('[data-plan-choices]');
      choices.replaceChildren();
      [...this.plan.options].forEach(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = option.textContent
          .replace(/^Deliver every week$/i, this.copy.weekly)
          .replace(/^Deliver every 2 weeks$/i, this.copy.fortnightly)
          .replace(/^Deliver every 4 weeks$/i, this.copy.fourWeekly);
        button.dataset.planChoice = option.value;
        button.disabled = this.plan.disabled || !option.value;
        button.setAttribute('aria-pressed', String(option.value === this.plan.value));
        button.addEventListener('click', () => {
          this.plan.value = option.value;
          this.dispatchFieldChange(this.plan);
        });
        choices.append(button);
      });
    }
    dispatchFieldChange(field) {
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
    flushPaymentFieldChanges() {
      const fields = this.pendingPaymentFields || [];
      this.pendingPaymentFields = [];
      fields.forEach(field => this.dispatchFieldChange(field));
    }
    updateSummary() {
      const quantity = Number(this.quantity.value);
      const selected = this.plan.selectedOptions[0];
      this.querySelectorAll('[data-plan-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.planChoice === this.plan.value)));
      this.querySelector('[data-step="-1"]').disabled = quantity <= Number(this.quantity.min);
      this.querySelector('[data-step="1"]').disabled = !!this.quantity.max && quantity >= Number(this.quantity.max);
      const valid = this.quantity.checkValidity();
      const purchasable = this.dataset.purchase === 'true' && this.variant?.dataset.available === 'true' && !!this.plan.value && selected?.dataset.price !== undefined;
      const validDate = !!this.selectedDate && this.allowed(this.parseDate(this.selectedDate));
      this.ready = purchasable && valid && validDate;
      this.querySelector('[data-total-price]').textContent = selected?.dataset.price !== undefined && valid ? new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.dataset.currency }).format(Number(selected.dataset.price) / 100) : this.copy.pricePending;
      const costLabels = [this.copy.costWeekly, this.copy.costFortnightly, this.copy.costFourWeekly];
      this.querySelector('[data-cost-label]').textContent = costLabels[this.plan.selectedIndex] || this.copy.pricePending;
      const submit = this.querySelector('[data-submit]');
      submit.disabled = !this.ready;
      submit.textContent = this.dataset.purchase !== 'true' ? this.copy.comingSoon : purchasable ? this.copy.subscribe : this.copy.unavailable;
      this.querySelectorAll('[data-variant],[data-date-value],[data-day-value]').forEach(input => input.disabled = !this.ready);
      const express = this.querySelector('[data-express]');
      if (express) express.hidden = !this.ready;
      const note = this.querySelector('[data-purchase-note]');
      note.hidden = purchasable;
      if (purchasable) note.textContent = this.copy.shipping;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-atri"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function updatePrice(root) {
      const price = root?.querySelector('.atri-price');
      if (!price) return;
      const quantity = root.querySelector('[name="quantity"]');
      const count = quantity ? Number(quantity.value) : 1;
      if (!Number.isInteger(count) || count < 1 || (quantity && !quantity.checkValidity())) return;
      const unit = Number(price.dataset.unitPrice);
      const compare = Number(price.dataset.comparePrice);
      const format = new Intl.NumberFormat(price.dataset.locale || 'en', { style: 'currency', currency: price.dataset.currency });
      price.replaceChildren();
      if (compare > unit) {
        const old = document.createElement('s');
        old.textContent = format.format(compare * count / 100);
        price.append(old, ' ');
      }
      price.append(document.createTextNode(format.format(unit * count / 100)));
    }
    for (const name of ['input', 'change']) document.addEventListener(name, event => {
      if (event.target.matches('.atri-pdp [name="quantity"]')) updatePrice(event.target.closest('.atri-pdp'));
    });
    document.addEventListener('atri:price-change', event => updatePrice(event.target.closest('.atri-pdp')));
    function init(scope) { scope.querySelectorAll('.atri-pdp').forEach(updatePrice); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-atri-variant]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
